import { Fatura } from '@/types/fatura'
import { formatDetalheCategoria, formatDetalheValor } from '@/services/fatura'
import { formatDate, formatDatetime, formatMoney } from '@/utils'
import { DetailedHTMLProps, TableHTMLAttributes } from 'react'

interface DetalheFaturaTableProps extends DetailedHTMLProps<TableHTMLAttributes<HTMLTableElement>, HTMLTableElement>
{
    detalhesFatura: Fatura['Detalhes']
}

export default function DetalheFaturaTable({ detalhesFatura, ...props }: DetalheFaturaTableProps) {
    if (!detalhesFatura || detalhesFatura.length < 1) return <></>
    return (
        <div className="table-responsive">
            <table {...props}>
                <thead>
                    <tr>
                        {
                            detalhesFatura[0].Tipo === 1 && (
                                <>
                                    <th>Data do Uso</th>
                                    <th>Serviços ou Produtos</th>
                                    <th>Valor</th>
                                </>
                            )
                        }
                        {
                            detalhesFatura[0].Tipo === 2 && (
                                <>
                                    <th>Plano</th>
                                    <th>Serviço Principal</th>
                                    <th>Animais</th>
                                    <th>Valor</th>
                                </>
                            )
                        }
                        {
                            detalhesFatura[0].Tipo === 3 && (
                                <>
                                    <th>Serviços ou Produtos</th>
                                    <th>Quantidade</th>
                                </>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {detalhesFatura?.map((detalheFatura, index) => {
                        if (detalheFatura.Tipo === 1) {
                            const dateText = detalheFatura.Data ? formatDate(detalheFatura.Data) : ''
                            const categoria = detalheFatura.Principal
                                ? formatDetalheCategoria(detalheFatura, dateText)
                                : ''
                            const valorExibido = formatDetalheValor(detalheFatura, formatMoney)

                            return (
                                <tr key={index}>
                                    <td>{formatDatetime(detalheFatura.Data)}</td>
                                    <td>
                                        {categoria ? <small>{categoria}</small> : null}
                                        <div>{detalheFatura.Descricao}</div>
                                    </td>
                                    <td>{valorExibido}</td>
                                </tr>
                            )
                        }

                        if (detalheFatura.Tipo === 2)
                            return (
                                <tr key={index}>
                                    <td>{detalheFatura.Frequencia}</td>
                                    <td>{detalheFatura.Descricao}</td>
                                    <td>{detalheFatura.Animais}</td>
                                    <td>{detalheFatura.ValorBase != null ? formatMoney(detalheFatura.ValorBase) : ''}</td>
                                </tr>
                            )

                        if (detalheFatura.Tipo === 3)
                            return (
                                <tr key={index}>
                                    <td>{detalheFatura.Descricao}</td>
                                    <td>{detalheFatura.Quantidade}</td>
                                </tr>
                            )

                        return <></>
                    })}
                </tbody>
            </table>
        </div>
    )
}
